import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import adminSession from '@/utils/adminSession'
import routePolicy from '@/utils/routePolicy'

function clearLoginState() {
    store.commit('SET_TOKEN', '')
    store.commit('RESET_ROUTES')
    adminSession.clearAdminToken()
}

// 【新增】递归查找第一个有效路由的辅助函数
function findFirstValidRoute(routes, basePath = '') {
    for (const route of routes) {
        // 跳过隐藏路由和 404
        if (route.hidden || route.path === '*') continue

        // 解析完整路径
        let fullPath = route.path
        if (!fullPath.startsWith('/')) {
            // 处理相对路径拼接
            fullPath = basePath + (basePath.endsWith('/') ? '' : '/') + fullPath
        }

        // 如果有子菜单，递归查找
        if (route.children && route.children.length > 0) {
            const childPath = findFirstValidRoute(route.children, fullPath)
            if (childPath) return childPath
        } else {
            // 是叶子节点（菜单），返回路径
            return fullPath
        }
    }
    return null
}

router.beforeEach(async(to, from, next) => {
    NProgress.start()
    if (routePolicy.isPortalEntry(to.path)) {
        next({ path: routePolicy.getDefaultRoute(), replace: true })
        return
    }

    if (routePolicy.isPortalRoute(to.path)) {
        next()
        return
    }

    const hasToken = adminSession.getAdminToken()

    if (hasToken) {
        if (routePolicy.isAdminLoginRoute(to.path)) {
            next({ path: routePolicy.ADMIN_ENTRY_ROUTE })
            NProgress.done()
        } else {
            const hasRoutes = store.state.hasLoadedRoutes

            if (hasRoutes) {
                // 访问后台入口时，自动跳转到第一个有效菜单
                if (to.path === routePolicy.ADMIN_ENTRY_ROUTE) {
                    const firstRoute = findFirstValidRoute(store.state.routes)
                    if (firstRoute) {
                        next({ path: firstRoute, replace: true })
                    } else {
                        // 如果没有任何菜单，就显示 404 或空白
                        next() 
                    }
                } else {
                    next()
                }
            } else {
                try {
                    const accessRoutes = await store.dispatch('GenerateRoutes')
                    
                    if (router.addRoutes) {
                        router.addRoutes(accessRoutes)
                    } else {
                        accessRoutes.forEach(r => router.addRoute(r))
                    }

                    // 加载完路由后，重新进入当前页面，触发后台入口跳转逻辑
                    next({ ...to, replace: true })
                } catch (error) {
                    clearLoginState()
                    next(`/login?redirect=${to.path}`)
                    NProgress.done()
                }
            }
        }
    } else {
        clearLoginState()
        if (routePolicy.isPublicRoute(to.path)) {
            next()
        } else {
            next(`/login?redirect=${to.path}`)
            NProgress.done()
        }
    }
})

router.afterEach(() => {
    NProgress.done()
})
